<template>
    <div class="layout-topbar">
        <div class="layout-topbar-wrapper">
            <div class="layout-topbar-left">
                <a tabindex="0" class="menu-button" @click="onMenuButtonClick">
                    <i class="pi pi-bars"></i>
                </a>
                <router-link id="logo-link" class="layout-topbar-logo" to="/">
                    <img src="../src/assets/layout/images/logininside.png" style="height: 40px; margin: -20px 0px 0px -10px" alt="Rai Planner" />

                    <!-- <img :src="'assets/layout/images/logo-' + (topbarTheme === 'dark' ? 'freya-white' : 'freya') + '.svg'" alt="freya-layout" /> -->
                </router-link>
            </div>

            <AppMenu
                @resize="renderModule"
                :layoutMode="layoutMode"
                :sidebarActive="sidebarActive"
                :sidebarStatic="sidebarStatic"
                :menuActive="menuActive"
                :mobileMenuActive="mobileMenuActive"
                @sidebar-mouse-leave="onSidebarMouseLeave"
                @sidebar-mouse-over="onSidebarMouseOver"
                @toggle-menu="onToggleMenu"
                @menu-click="onMenuClick"
                @menuitem-click="onMenuItemClick"
                @root-menuitem-click="onRootMenuItemClick"
            />
            <div v-show="renderModuleName">
                <ul class="layout-topbar-actions">
                    <li style="list-style-type: none; font-weight: bold; font-size: large">
                        <span v-if="$route.name === 'Add Job Post'"
                            ><i class="pi pi-chevron-left" style="font-weight: bold" @click="openResponsive"></i><b> {{ topbar($route.name) }}</b>
                        </span>
                        <span v-else
                            ><i class="pi pi-chevron-left" style="font-weight: bold" @click="$router.go(-1)"></i><b> {{ topbar($route.name) }}</b>
                        </span>
                    </li>
                </ul>
            </div>

            <div class="layout-topbar-right">
                <ul class="layout-topbar-actions">
                    <!-- <li>
                        <LanguageInput />
                    </li> -->
                    <!-- <li>
                        <h6 style="margin-top: 11px">{{ adminType }}</h6>
                    </li> -->
                    <!-- <li ref="search" class="topbar-item search-item" :class="{ 'active-topmenuitem': searchActive }">
                        <a tabindex="0" @click="onTopbarSearchToggle">
                            <i class="topbar-icon pi pi-search"></i>
                        </a>

                        <div class="search-input-wrapper" @click="onTopbarSearchClick">
                            <span class="p-input-icon-left">
                                <i class="pi pi-search"></i>
                                <InputText ref="desktopInput" type="text" placeholder="Search..." @keydown="onInputKeydown" />
                            </span>
                        </div>

                        <ul class="fadeInDown">
                            <div class="search-input-wrapper p-fluid" style="width: 100%" @click="onTopbarSearchClick">
                                <span class="p-input-icon-left">
                                    <i class="pi pi-search"></i>
                                    <InputText ref="phoneInput" type="text" placeholder="Search..." @keydown="onInputKeydown" />
                                </span>
                            </div>
                        </ul>
                    </li>-->

                    <li ref="profile" class="topbar-item user-profile" :class="{ 'active-topmenuitem fadeInDown': topbarUserMenuActive }">
                        <a @click="onTopbarUserMenuClick">
                            <img src="../src/assets/layout/images/user.png" alt="user" />
                        </a>

                        <h6 style="margin-top: 11px" @click="onTopbarUserMenuClick">{{ adminType === 'super_admin' ? 'SuperAdmin' : 'Admin' }}</h6>
                        <i class="pi pi-angle-down" @click="onTopbarUserMenuClick"></i>
                        <ul class="fadeInDown">
                            <!-- <li v-show="render" @click="personalinfo">
                                <div>
                                    <span>{{$t('dfc_user.personal_info')}}</span>
                                </div>
                            </li> -->
                            <li v-show="render" @click="Accountinfo" :style="$route.path == '/modify-info' ? 'background-color: blue;color:#fff;' : 'background-color: none;'">
                                <div>
                                    <span>{{ $t('Account Info') }}</span>
                                </div>
                            </li>
                            <!-- <li @click="changepass">
                                <div>
                                    <span>{{$t('Change Password')}}</span>
                                </div>
                            </li>
                            <li @click="logout">
                                <div>
                                    <span>{{$t('button.logout')}}</span>
                                </div> -->
                            <!-- <li @click="changepass"
                                :style="$route.path == '/change-pass' ? 'background-color: blue;color:#fff;' : 'background-color: none;'">
                                <div>
                                    <span>{{ $t('Change Password') }}</span>
                                </div>
                            </li> -->
                            <li @click="logout">
                                <div>
                                    <span>{{ $t('logout') }}</span>
                                </div>
                            </li>
                        </ul>
                    </li>
                </ul>

                <!-- <a href="#" tabindex="0" class="layout-rightpanel-button" @click="onRightMenuButtonClick($event)">
                    <i class="pi pi-arrow-left"></i>
                </a>-->
                <Dialog modal :header="$t('OtherPlatform.Add.Alert')" v-model:visible="displayResponsive" :breakpoints="{ '960px': '75vw', '640px': '90vw' }" :style="{ width: '21vw' }">
                    <p class="text-choose">
                        <b>{{ $t('OtherPlatform.Add.ConfirmText') }}</b>
                    </p>
                    <div class="p-grid p-formgrid p-mb-3">
                        <div class="p-col-12 p-mb-2 p-lg-12 p-mb-lg-0 p-field">
                            <b id="head11">{{ $t('OtherPlatform.Add.ConfirmText2') }}</b>
                        </div>
                    </div>

                    <template #footer>
                        <div class="p-d-flex p-jc-end p-ai-center dual-btn" style="float: left">
                            <Button :label="$t('OtherPlatform.list.Confirm')" icon="pi pi-check" @click="GoBack()" id="reject" />
                        </div>
                        <div class="p-d-flex p-jc-end p-ai-center dual-btn" style="float: right">
                            <Button :label="$t('OtherPlatform.list.Cancel')" icon="pi pi-replay" @click="closeResponsive" class="p-button p-button p-button-outlined" id="close" style="background: white; color: black" />
                        </div>
                    </template>
                </Dialog>
            </div>
        </div>
    </div>
</template>

<script>
import AppMenu from './AppMenu';
// import LanguageInput from './components/LanguageInput.vue';
export default {
    name: 'AppTopbar',
    data() {
        return {
            adminType: localStorage.getItem('admin-type'),
            render: false,
            renderModuleName: false,
            id: localStorage.getItem('admin-ID'),
            logoathena: '../src/assets/layout/images/logininside.png',
            displayResponsive: false,
        };
    },
    emits: [
        'menu-click',
        'menuitem-click',
        'root-menuitem-click',
        'menu-button-click',
        'toggle-menu',
        'right-menubutton-click',
        'sidebar-mouse-over',
        'sidebar-mouse-leave',
        'topbar-search-toggle',
        'topbar-search-click',
        'topbar-search-hide',
        'topbar-usermenu-click',
        'update:searchClick',
    ],
    props: {
        searchActive: Boolean,
        searchClick: Boolean,
        topbarItemClick: Boolean,
        topbarUserMenuActive: Boolean,
        topbarUserMenuClick: Boolean,
        activeTopbarItem: String,
        sidebarActive: Boolean,
        sidebarStatic: Boolean,
        layoutMode: String,
        topbarTheme: String,
        menuActive: Boolean,
        mobileMenuActive: Boolean,
    },
    unmounted() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    },
    mounted() {
        // console.log(this.adminType)
        this.renderModule();
        window.addEventListener('resize', this.renderModule);
        // window.location = localStorage.getItem("DynamicPath");
        // this.$router.push({ path: localStorage.getItem("DynamicPath") });
    },
    methods: {
        GoBack(){
            this.displayResponsive = false
            this.$router.go(-1)
        },
        openResponsive() {
            this.displayResponsive = true;
        },
        closeResponsive() {
            this.displayResponsive = false;
        },
        renderModule() {
            if (window.innerWidth < 1000) {
                this.renderModuleName = false;
            } else {
                this.renderModuleName = true;
            }
        },
        Accountinfo() {
            this.$router.push({ path: '/modify-info/' + this.id });
        },
        topbar(name) {
            return this.$t(String(name));
        },
        onMenuClick(event) {
            this.$emit('menu-click', event);
        },
        onMenuItemClick(event) {
            this.$emit('menuitem-click', event);
        },
        onRootMenuItemClick(event) {
            this.$emit('root-menuitem-click', event);
        },
        onMenuButtonClick(event) {
            this.$emit('menu-button-click', event);
        },
        onToggleMenu(event) {
            this.$emit('toggle-menu', event);
        },
        onTopbarSearchToggle(event) {
            this.$emit('topbar-search-toggle', event);
            this.onSearchFocus();
        },
        onTopbarSearchClick(event) {
            this.$emit('topbar-search-click', event);
        },
        onInputKeydown(event) {
            const key = event.which;

            //escape, tab and enter
            if (key === 27 || key === 9 || key === 13) {
                this.$emit('topbar-search-hide', event);
            }
        },
        onTopbarUserMenuClick(event) {
            this.render = this.admin == 'admin' ? false : true;
            this.$emit('topbar-usermenu-click', event);
        },
        onRightMenuButtonClick(event) {
            this.$emit('right-menubutton-click', event);
        },
        onSidebarMouseOver() {
            this.$emit('sidebar-mouse-over');
        },
        onSidebarMouseLeave() {
            this.$emit('sidebar-mouse-leave');
        },
        logout() {
            localStorage.removeItem('AdminName');
            localStorage.removeItem('AdminId');
            localStorage.removeItem('token');
            this.$router.push({ name: 'login' });
        },
        changepass() {
            this.$router.push({ name: 'ChangePass' });
        },
        personalinfo() {
            this.$router.push({ name: 'EditInfo' });
        },
        uploadDoc() {
            this.$router.push({ name: 'UploadedDoclist' });
        },
        onSearchFocus() {
            if (window.innerWidth >= 576) {
                this.$refs.desktopInput.$el.focus();
            } else {
                this.$nextTick(function () {
                    this.$refs.phoneInput.$el.focus();
                });
            }
        },
    },
    components: {
        AppMenu,
        // LanguageInput,
    },
};
</script>
<style scoped>
.flow {
    background-color: blue;
    color: #fff;
}

.pi-chevron-left:hover {
    background-color: #464df2;
    transition: 400ms;
    color: #fff;
}

.pi-chevron-left {
    border-radius: 50%;
    padding: 5px;
    background-color: rgb(218, 219, 223);
}
p.text-choose {
    text-align: center;
    margin-top: 20px;
}
b#head11 {
    text-align: center;
    display: block;
}
</style>
